<template>
  <div class="row">
    <div v-if="readingFromBle" class="loading-overlay">
      <LoadingPlaceholder/>
    </div>
    <div class="col-12 d-flex justify--space-between clickable">
      <h5> {{ $t('checkup_plus.person.measurements.create.data_to_insert') }}</h5>
      <i v-if="isBleAvailable" class="fa-brands fa-bluetooth-b" style="font-size: 30px; color: #223fb9" @click="handleBluetoothRead"></i>
    </div>
    <div class="col-12 d-flex">
      <div class="col-6 form-group">
        <va-date-picker
          class="w-100"
          v-model="form.date"
          :placeholder="$t('iframe.table_headings.created_at')"
          :label="$t('iframe.table_headings.created_at')"
          :config="{
            defaultDate: appointmentDates.start,
            enableTime: true,
            maxDate: moment(appointmentDates.end).toDate(),
            minDate: moment(appointmentDates.start).toDate(),
            time_24hr: true,
            minuteIncrement: 15,
            dateFormat: 'Y/m/d H:i'}"
        />
      </div>
        <div class="col-6 form-group">
          <va-input
            type="number"
            step="0.1"
            max="6"
            min="0"
            :error="errors.forcedExpiratoryVol6Sec.length > 0"
            :error-messages="errors.forcedExpiratoryVol6Sec"
            v-model="form.forcedExpiratoryVol6Sec"
            :placeholder="$t('dashboard_new_evollu.measurement_types.forced_expiratory_volume_6_sec_short')+' (L)'"
            :label="$t('dashboard_new_evollu.measurement_types.forced_expiratory_volume_6_sec_short')+' (L)'"
            required
            :disabled="measuresFromBle"
            :v-bind:class="{'error': true}"
          />
        </div>


    </div>

    <div class="col-12 d-flex">
      <div class="col-6 form-group">
        <va-input
          type="number"
          step="0.1"
          max="6"
          min="0"
          :error="errors.forcedExpiratoryVol1Sec.length > 0"
          :error-messages="errors.forcedExpiratoryVol1Sec"
          v-model="form.forcedExpiratoryVol1Sec"
          :placeholder="$t('dashboard_new_evollu.measurement_types.forced_expiratory_volume_1_sec_short')+' (L)'"
          :label="$t('dashboard_new_evollu.measurement_types.forced_expiratory_volume_1_sec_short')+' (L)'"
          required
          :v-bind:class="{'error': true}"
          :disabled="measuresFromBle"
        />
      </div>
      <div class="col-6 form-group">
        <va-input
          type="number"
          step="0.1"
          max="1"
          min="0"
          :error="errors.fev1fev6.length > 0"
          :error-messages="errors.fev1fev6"
          v-model="form.fev1fev6"
          :placeholder="$t('dashboard_new_evollu.measurement_types.fev1_fev6_short')"
          :label="$t('dashboard_new_evollu.measurement_types.fev1_fev6_short')"
          required
          :disabled="measuresFromBle"
        />
      </div>
    </div>
    <div class="col-12 d-flex">
      <div class="col-6 form-group">
        <va-input
          type="number"
          step="0.1"
          max="1000"
          min="0"
          :error="errors.forcedMidExpiratoryFlow.length > 0"
          :error-messages="errors.forcedMidExpiratoryFlow"
          v-model="form.forcedMidExpiratoryFlow"
          :placeholder="$t('dashboard_new_evollu.measurement_types.forced_mid_expiratory_flow_25_75_short')+' (L/s)'"
          :label="$t('dashboard_new_evollu.measurement_types.forced_mid_expiratory_flow_25_75_short')+' (L/s)'"
          required
          :disabled="measuresFromBle"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import LoadingPlaceholder from "@/components/common/LoadingPlaceholder.vue";
import HandleBluetoothMixin
  from "@/components/checkup_plus/patients/ParametersDetails/MeasurementsCreation/HandleBluetoothMixin.vue";

const FORCED_EXPIRATORY_VOLUME_6_TYPE_ID = 21
const FORCED_EXPIRATORY_VOLUME_1_TYPE_ID = 22
const FEV1_FEV6_TYPE_ID = 23
const FORCED_MID_EXPIRATORY_FLOW = 57
export default {
  components: {LoadingPlaceholder},
  mixins: [
    HandleBluetoothMixin
  ],
  props: {
    measurement: {
      type: Object,
      required: true
    },
    appointmentDates: {
      type: Object,
      mandatory: true,
    },
  },
  data() {
    return {
      form: {
        date: this.appointmentDates.start,
        forcedExpiratoryVol6Sec: null,
        forcedExpiratoryVol1Sec: null,
        fev1fev6: null,
        forcedMidExpiratoryFlow: null,
        equipmentType: null
      },
      errors: {
        forcedExpiratoryVol6Sec: [],
        forcedExpiratoryVol1Sec: [],
        fev1fev6: [],
        forcedMidExpiratoryFlow: []
      }
    }
  },
  created() {
    this.measurement.measurementTypeId = 11
  },
  methods: {
    checkCanSubmit() {
      let canSubmit = (this.form.forcedExpiratoryVol6Sec !== null && this.form.forcedExpiratoryVol6Sec !== '') &&
        (this.form.forcedExpiratoryVol1Sec !== null && this.form.forcedExpiratoryVol1Sec !== '') &&
        (this.form.fev1fev6 !== null && this.form.fev1fev6 !== '') &&
        (this.form.forcedMidExpiratoryFlow !== null && this.form.forcedMidExpiratoryFlow !== '')

        this.$emit('updateCanSubmit', canSubmit)
    }
  },
  watch: {
    "form.forcedExpiratoryVol6Sec": function(value) {
      this.checkCanSubmit()
      if(value !== '' && (value < 1 || value > 6)) {
        this.errors.forcedExpiratoryVol6Sec = [this.$t('checkup_plus.person.measurements.create.messages.errors.value_must_be_between_min_max', {min: 1, max: 6})]
      }
      else {
        this.errors.forcedExpiratoryVol6Sec = []
      }

      if(this.measurement.measurements.find(meas => meas.typeId === FORCED_EXPIRATORY_VOLUME_6_TYPE_ID)) {
        let elem = this.measurement.measurements.find(meas => meas.typeId === FORCED_EXPIRATORY_VOLUME_6_TYPE_ID)
        elem.value = this.errors.forcedExpiratoryVol6Sec.length === 0 ? value : null
      } else {
        this.measurement.measurements.push({
          value: this.errors.forcedExpiratoryVol6Sec.length === 0 ? value : null,
          typeId: FORCED_EXPIRATORY_VOLUME_6_TYPE_ID,
          equipmentType: this.form.equipmentType
        })
      }
    },
    "form.forcedExpiratoryVol1Sec": function(value) {
      this.checkCanSubmit()
      if(value !== '' && (value < 1 || value > 6)) {
        this.errors.forcedExpiratoryVol1Sec = [this.$t('checkup_plus.person.measurements.create.messages.errors.value_must_be_between_min_max', {min: 1, max: 6})]
      }
      else {
        this.errors.forcedExpiratoryVol1Sec = []
      }

      if(this.measurement.measurements.find(meas => meas.typeId === FORCED_EXPIRATORY_VOLUME_1_TYPE_ID)) {
        let elem = this.measurement.measurements.find(meas => meas.typeId === FORCED_EXPIRATORY_VOLUME_1_TYPE_ID)
        elem.value = this.errors.forcedExpiratoryVol1Sec.length === 0 ? value : null
      } else {
        this.measurement.measurements.push({
          value: this.errors.forcedExpiratoryVol1Sec.length === 0 ? value : null,
          typeId: FORCED_EXPIRATORY_VOLUME_1_TYPE_ID,
          equipmentType: this.form.equipmentType
        })
      }
    },
    "form.fev1fev6": function(value) {
      this.checkCanSubmit()
      if(value !== '' && (value < 0 || value > 1)) {
        this.errors.fev1fev6 = [this.$t('checkup_plus.person.measurements.create.messages.errors.value_must_be_between_min_max', {min: 0, max: 1})]
      }
      else {
        this.errors.fev1fev6 = []
      }

      if(this.measurement.measurements.find(meas => meas.typeId === FEV1_FEV6_TYPE_ID)) {
        let elem = this.measurement.measurements.find(meas => meas.typeId === FEV1_FEV6_TYPE_ID)
        elem.value = this.errors.fev1fev6.length === 0 ? value : null
      } else {
        this.measurement.measurements.push({
          value: this.errors.fev1fev6.length === 0 ? value : null,
          typeId: FEV1_FEV6_TYPE_ID,
          equipmentType: this.form.equipmentType
        })
      }
    },
    "form.forcedMidExpiratoryFlow": function(value) {
      this.checkCanSubmit()
      if(value !== '' && (value < 1 || value > 6)) {
        this.errors.forcedMidExpiratoryFlow = [this.$t('checkup_plus.person.measurements.create.messages.errors.value_must_be_between_min_max', {min: 1, max: 1000})]
      }
      else {
        this.errors.forcedMidExpiratoryFlow = []
      }

      if(this.measurement.measurements.find(meas => meas.typeId === FORCED_MID_EXPIRATORY_FLOW)) {
        let elem = this.measurement.measurements.find(meas => meas.typeId === FORCED_MID_EXPIRATORY_FLOW)
        elem.value = this.errors.forcedMidExpiratoryFlow.length === 0 ? value : null
      } else {
        this.measurement.measurements.push({
          value: this.errors.forcedMidExpiratoryFlow.length === 0 ? value : null,
          typeId: FORCED_MID_EXPIRATORY_FLOW,
          equipmentType: this.form.equipmentType
        })
      }
    },
    appointmentDates: {
      immediate: true,
      deep:true,
      handler (value) {
        this.form.date = value.start
        this.measurement.date = moment(value.start).valueOf()
      }
    },
    'form.date': function (value) {
      if(value !== null) {
        this.measurement.date = moment(value).valueOf()
      } else {
        this.measurement.date = null
      }
    }

  }
}
</script>

<style scoped>

</style>
